import apiService from './api.service';
import { API_ENDPOINTS } from '../config/api.config';
import {
  ApiKey,
  ApiKeyListResponse,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  UpdateApiKeyRequest,
} from '../types/api.types';

class ApiKeyService {
  async listKeys(): Promise<ApiKey[]> {
    const response = await apiService.get<ApiKeyListResponse>(API_ENDPOINTS.API_KEY.LIST);
    return response.data.apiKeys ?? [];
  }

  async createKey(data: CreateApiKeyRequest): Promise<CreateApiKeyResponse> {
    return await apiService.post<CreateApiKeyResponse>(API_ENDPOINTS.API_KEY.CREATE, data);
  }

  async updateKey(id: string, data: UpdateApiKeyRequest): Promise<ApiKey> {
    return await apiService.put<ApiKey>(API_ENDPOINTS.API_KEY.UPDATE(id), data);
  }

  async revokeKey(id: string): Promise<ApiKey> {
    return await apiService.patch<ApiKey>(API_ENDPOINTS.API_KEY.REVOKE(id));
  }

  async deleteKey(id: string): Promise<void> {
    await apiService.delete(API_ENDPOINTS.API_KEY.DELETE(id));
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ApiKeyService();
